import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import StickyCallBar from "@/components/site/StickyCallBar";
import ScrollToTop from "@/components/site/ScrollToTop";
import CookieBanner from "@/components/site/CookieBanner";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Realisations from "@/pages/Realisations";
import APropos from "@/pages/APropos";
import Contact from "@/pages/Contact";
import GoogleBusiness from "@/pages/GoogleBusiness";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import { CityPage, ServicePage } from "@/pages/LocalPage";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="min-h-[60vh]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nos-services" element={<Services />} />
            <Route path="/realisations" element={<Realisations />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/google-business" element={<GoogleBusiness />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            {/* SEO local — pages villes */}
            <Route path="/plombier-colmar" element={<CityPage />} />
            <Route path="/plombier-beblenheim" element={<CityPage />} />
            <Route path="/plombier-ribeauville" element={<CityPage />} />
            <Route path="/plombier-kaysersberg" element={<CityPage />} />
            <Route path="/plombier-selestat" element={<CityPage />} />
            {/* SEO local — pages services */}
            <Route path="/depannage-plomberie-colmar" element={<ServicePage />} />
            <Route path="/urgence-plombier-colmar" element={<ServicePage />} />
            <Route path="/recherche-fuite-colmar" element={<ServicePage />} />
            <Route path="/debouchage-canalisation-colmar" element={<ServicePage />} />
            <Route path="/chauffagiste-colmar" element={<ServicePage />} />
            <Route path="/entretien-chaudiere-colmar" element={<ServicePage />} />
            <Route path="/installation-vmc-colmar" element={<ServicePage />} />
            <Route path="/renovation-salle-de-bain-colmar" element={<ServicePage />} />
            {/* Catch-all 404 → home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <StickyCallBar />
        <CookieBanner />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
